import React, { useEffect, useState } from 'react';
import { getCategories, addCategory, deleteCategory } from '../../firebase/firestore';
import './ManageCategories.css';

const DEFAULT_CATS = ['Politics','Sports','Technology','Entertainment','Business','World','Health','Education'];

export default function ManageCategories() {
  const [cats, setCats] = useState([]);
  const [newCat, setNewCat] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    const data = await getCategories();
    setCats(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    const name = newCat.trim();
    if (!name) return setError('Please enter a category name');
    if (cats.some(c => c.name.toLowerCase() === name.toLowerCase())) return setError('Category already exists');
    setError('');
    await addCategory(name);
    setNewCat('');
    load();
  };

  const handleDelete = async (cat) => {
    if (!window.confirm(`Delete category "${cat.name}"? Articles in this category won't be deleted.`)) return;
    await deleteCategory(cat.id);
    setCats(prev => prev.filter(c => c.id !== cat.id));
  };

  const seedDefaults = async () => {
    for (const name of DEFAULT_CATS) {
      if (!cats.some(c => c.name === name)) {
        await addCategory(name);
      }
    }
    load();
  };

  return (
    <div className="manage-categories">
      <div className="page-header-row">
        <h1 className="page-title">🏷️ Manage Categories</h1>
        {cats.length === 0 && (
          <button className="btn btn-secondary btn-sm" onClick={seedDefaults}>+ Seed Default Categories</button>
        )}
      </div>

      <div className="cats-layout">
        <div className="cat-form-card">
          <h2 className="card-section-title">Add New Category</h2>
          {error && <div className="form-error">{error}</div>}
          <form onSubmit={handleAdd} className="cat-add-form">
            <div className="form-group">
              <label>Category Name *</label>
              <input value={newCat} onChange={e => setNewCat(e.target.value)} placeholder="e.g. Science & Nature" maxLength={40} />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>➕ Add Category</button>
          </form>

          <div className="cat-tips">
            <h4>💡 Tips</h4>
            <ul>
              <li>Categories appear in the navigation dropdown</li>
              <li>You can assign categories when adding articles</li>
              <li>Deleting a category won't delete its articles</li>
            </ul>
          </div>
        </div>

        <div className="cat-list-card">
          <h2 className="card-section-title">All Categories ({cats.length})</h2>
          {loading ? <div className="loading-spinner">Loading...</div>
            : cats.length === 0
              ? (
                <div className="empty-state">
                  <h3>No categories yet</h3>
                  <p>Click "Seed Default Categories" to add standard news categories</p>
                </div>
              )
              : (
                <div className="cats-grid">
                  {cats.map(cat => (
                    <div key={cat.id} className="cat-item">
                      <span className="cat-icon">🏷️</span>
                      <span className="cat-name">{cat.name}</span>
                      <span className="cat-slug">/{cat.slug}</span>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(cat)}>Delete</button>
                    </div>
                  ))}
                </div>
              )
          }
        </div>
      </div>
    </div>
  );
}
